var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#help-icon_svg__clip0_2551_11433)",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.403A6.667 6.667 0 108 2.07a6.667 6.667 0 000 13.333zM8 12.07h.007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06 6.736a2 2 0 013.886.667c0 1.333-2 2-2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "help-icon_svg__clip0_2551_11433"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .736)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/help-icon.61884b89.svg";
export { SvgHelpIcon as ReactComponent };